import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ChunkyButton from 'client/app/apps/disco-prototype/components/ChunkyButton';
import EditableLabel from 'client/app/apps/disco-prototype/components/EditableLabel';
import ActionsList from 'client/app/apps/disco-prototype/components/Steps/ActionsList';
import StepItem from 'client/app/apps/disco-prototype/components/Steps/StepItem';
import {
  StepSelect,
  StepSelector,
} from 'client/app/apps/disco-prototype/components/Steps/StepSelector';
import { DeviceOption } from 'client/app/apps/disco-prototype/DeviceConfigProvider';
import { LiquidSet } from 'client/app/apps/disco-prototype/state/liquidSet';
import { Step } from 'client/app/apps/disco-prototype/state/steps';

const TEAL_COLOR = '#4CC3B6'; // TODO: FIXME we should add this color to theme

type Props = {
  steps: Step[];
  targetOptions: LiquidSet[];
  deviceOptions: DeviceOption[];
  handleAddStep: () => void;
  handleDeleteStep: (id: string) => void;
  handleUpdateStep: (id: string, update: Record<string, any>) => void;
};

const Steps: React.FC<Props> = ({
  steps,
  targetOptions,
  deviceOptions,
  handleAddStep,
  handleDeleteStep,
  handleUpdateStep,
}) => {
  return (
    <Stack spacing={8} px={4}>
      {steps.map(step => (
        <Stack
          key={step.id}
          spacing={4}
          sx={{ borderLeft: `4px solid ${TEAL_COLOR}`, pl: 4 }}
        >
          <StepItem onDelete={() => handleDeleteStep(step.id)}>
            <EditableLabel
              value={step.name}
              onChange={name => handleUpdateStep(step.id, { name })}
              variant="h2"
            />
          </StepItem>

          <Stack spacing={4} sx={{ alignSelf: 'start' }}>
            <StepSelector
              Header={
                <Typography
                  variant="h6"
                  alignSelf="center"
                  sx={{ fontWeight: 'bold', color: 'text.primary' }}
                >
                  Device
                </Typography>
              }
              headerColor={TEAL_COLOR}
              Body={
                <StepSelect
                  value={step.device || ''}
                  label="Select device"
                  options={deviceOptions}
                  onChange={e => handleUpdateStep(step.id, { device: e.target.value })}
                  sx={{ minWidth: '200px' }}
                />
              }
            />
            <StepSelector
              headerColor={TEAL_COLOR}
              Header={
                <Typography
                  variant="h6"
                  alignSelf="center"
                  sx={{ fontWeight: 'bold', color: 'text.primary' }}
                >
                  Target output
                </Typography>
              }
              Body={
                <StepSelect
                  value={step.target?.id || ''}
                  label="Select liquid set"
                  options={targetOptions.map(si => ({
                    value: `${si.id}`,
                    label: si.name,
                  }))}
                  onChange={e => handleUpdateStep(step.id, { target: e.target.value })}
                  sx={{ minWidth: '200px' }}
                />
              }
            />
          </Stack>

          <ActionsList
            stepId={step.id}
            target={step.target}
            actions={step.actions}
            liquidSets={targetOptions}
            handleUpdateStep={handleUpdateStep}
          />
        </Stack>
      ))}

      <Box>
        <ChunkyButton
          backgroundColor="white"
          startIcon={<AddIcon />}
          onClick={handleAddStep}
        >
          Add Step
        </ChunkyButton>
      </Box>
    </Stack>
  );
};

export default Steps;
